import { useEffect, useState } from 'react';
import { useTheme } from '@/components/theme-provider';

const DARK_QUERY = '(prefers-color-scheme: dark)';

/**
 * Returns the theme actually shown ('light' or 'dark'), resolving 'system' from the OS preference
 * and following changes to it.
 */
export function useResolvedTheme(): 'light' | 'dark' {
  const { theme } = useTheme();
  const [systemDark, setSystemDark] = useState(() => window.matchMedia(DARK_QUERY).matches);

  useEffect(() => {
    const mql = window.matchMedia(DARK_QUERY);
    const onChange = () => {
      setSystemDark(mql.matches);
    };
    mql.addEventListener('change', onChange);
    setSystemDark(mql.matches);
    return () => {
      mql.removeEventListener('change', onChange);
    };
  }, []);

  if (theme === 'system') {
    return systemDark ? 'dark' : 'light';
  }

  return theme;
}
